export const DBS = "DBS"
export const SALIVA = "SALIVA"
export const SERUM = "SERUM"
export const WELLNESS_DBS = "WDBS"
export const WELLNESS = "WELL"